var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"table"},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.data,"loading":_vm.loading}})],1),_c('div',{staticClass:"page"},[_c('Page',{attrs:{"total":_vm.total,"current":_vm.page,"show-total":"","show-sizer":"","show-elevator":""},on:{"on-change":_vm.changePage,"on-page-size-change":_vm.changePageSize}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }